import React from 'react';
import './footerStyle.css';
import {Navbar, Container, Col} from 'react-bootstrap'
import telegram from "../../assets/logoAndIcons/telegram.png"
import instagram from "../../assets/logoAndIcons/instagram.png"
import email from "../../assets/logoAndIcons/email.png"
import MyComponent from "../Hooks/MyComponent";
import ScriptTag from 'react-script-tag'
import {Helmet} from "react-helmet";

class Footer extends React.Component {

    // componentDidMount() {
    //     const script = document.createElement("script");
    //     script.async = true;
    //     script.src = "https://cdn.zarinpal.com/trustlogo/v1/trustlogo.js";
    //     this.div.appendChild(script);
    // }

    // componentDidMount() {
    //     const script = document.createElement("script");
    //
    //     script.src = "https://cdn.zarinpal.com/trustlogo/v1/trustlogo.js";
    //     script.async = true;
    //     script.type = "text/javascript";
    //     document.body.appendChild(script);
    // }

    // zrinpal = () => {
    //     return (
    //         <script src="https://cdn.zarinpal.com/trustlogo/v1/trustlogo.js" type="text/javascript"></script>
    //     )
    // }
    // terms = () => {
    //     this.props.history.replace({
    //             pathname: './terms'
    //         }
    //     )
    // }
    // faq = () => {
    //     this.props.history.replace({
    //             pathname: './faq'
    //         }
    //     )
    // }

    render() {
        return (
            <footer className="footer text-faded text-center py-5">
                <div className="footerContainer" ref={el => (this.div = el)}>

                    <ul className="list-inline mb-0" style={{margin: "auto"}}>

                        <li className="list-inline-item">
                            <a
                                // target="_blank"
                                href="mailto:support@molino.ir?subject=Feedback%20for%20Molino">
                                <img className="footerImgE" src={email}/></a>

                        </li>
                        <li className="list-inline-item">
                            <a
                                // target="_blank"
                                href="https://instagram.com/molino_ir?igshid=kv98nyyd4z8c">
                                <img className="footerImgI" src={instagram}/></a>
                        </li>
                        <li className="list-inline-item">
                            <a
                                // target="_blank"
                                href="https://t.me/Jobaccount">
                                <img className="footerImgT" src={telegram}/></a>
                        </li>
                    </ul>
                    {/*<Helmet>*/}
                    {/*    <script src="https://cdn.zarinpal.com/trustlogo/v1/trustlogo.js" type="text/javascript"/>*/}
                    {/*</Helmet>*/}
                    {/*<ScriptTag  src="https://cdn.zarinpal.com/trustlogo/v1/trustlogo.js" type="text/javascript"/>*/}
                    {/*<MyComponent/>*/}
                    <div className="footerText">
                        <p className="footerT">
                            تمامی حقوق مادی و معنوی متعلق به مالینو می&nbsp;باشد.
                        </p>
                        <p className={"footerT"} style={{fontSize: ".7rem"}}>
                            طراحی شده توسط شرکت&nbsp; <a className={"techsana"} href={"https://www.techsana.net/"}>تکسانا</a>
                        </p>
                        <p className={"footerT"} style={{fontSize: ".7rem"}}>
                            آدرس : تهران - خیابان مطهری، بعد از سهروردی، خیابان یوسفیان، پلاک 123 واحد 4
                        </p>
                        <p className={"footerT"} style={{fontSize: ".7rem"}}>
                            شماره تماس : 88410916-021
                        </p>
                    </div>
                    <ul className={"footerLink"}>
                        <li className={"footerLinkLi"}>
                            <a className={"footerLinkA"} href={"/terms"}>قوانین و مقررات</a>
                        </li>
                        <li className={"footerLinkLi"}>
                            <a className={"footerLinkA"} href={"/faq"} >سوالات متداول</a>
                        </li>

                    </ul>


                </div>
            </footer>

        )
    }


}


export default Footer;
